import Box from "@/common/components/Box";
import Select from "@/common/components/Select";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { SearchIcon } from "lucide-react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { NegotiationValidationSchema } from "../../schemas/negotiation.schema";
import { Option } from "@/common/types/option";
import NegotiatingProductItem from "./NegotiatingProductItem";
import { EstablishmentCompanyData } from "@/features/company/types/company.type";
import { useNegotiationsApplicableProducts } from "../../hooks/useNegotiationsApplicableProducts";
import { NegotiationAvailableProductData } from "../../types/applicableProduct.type";

interface NegotiatingProductsProps {
  establishment?: EstablishmentCompanyData;
}

const NegotiatingProducts = ({ establishment }: NegotiatingProductsProps) => {
  const { control } = useFormContext<NegotiationValidationSchema>();

  const {
    fields: products,
    append: appendProduct,
    remove: removeProduct,
  } = useFieldArray({
    control,
    name: 'negotiation_products_attributes',
  });

  const [searchProduct, setSearchProduct] = useDebounce('');

  const { data: applicableProductsOptions } = useNegotiationsApplicableProducts({
    filters: {
      search: searchProduct,
      establishment_id: establishment?.id,
    },
    mapper: Mapper.mapToOptionsWithItem({ valueFieldName: 'id', labelFieldName: 'display_name' }),
  });

  return (
    <Box className="flex flex-col gap-4">
      <p>Produtos em negociação</p>

      <Select
        placeholder={(
          <div className="flex items-center gap-2">
            <SearchIcon />

            <p>Procure produtos</p>
          </div>
        )}
        options={applicableProductsOptions.filter((productOption) => !products.map((product) => product.product_id).includes(productOption.value))}
        onInputChange={setSearchProduct}
        value={''}
        onChange={(option) => appendProduct({
          product_id: (option as Option).value,
          product: (option as { item: NegotiationAvailableProductData }).item,
          value: '',
          quantity: '',
        })}
      />

      {products.map((product, index) => (
        <NegotiatingProductItem
          key={product.id}
          index={index}
          onDelete={() => removeProduct(index)}
          product={product.product}
        />
      ))}
    </Box>
  );
};

export default NegotiatingProducts;
